import { SET_TERMINAL, SET_ACCESSORIAL_RATE_UI} from './AccessorialsAndFeesUiActions';
import { combineReducers } from 'redux';
import { Map } from 'immutable';

let defaultState = new Map({
  terminalId: null
});


function terminal(state = defaultState, action) {
  switch (action.type) {
    case SET_TERMINAL:
      return state.merge(Map({
        terminalId: action.terminalId
      }));
    default:
      return state;
  }
}


function accessorialRateUi(state = new Map({
  sortColumn: null,
  sortDirection: null,
  terminalId: null,
  // data: [],
  filters: {},
  selectedIndexes: [],
  selectedObjects: [],
  selectedTerminal: null
}), action) {
  switch (action.type) {
    case SET_ACCESSORIAL_RATE_UI:
      return state.merge(Map({
        ...action
      }));
    default:
      return state;
  }
}


const rateManagement = combineReducers({
  terminal,
  accessorialRateUi,
});

export default rateManagement;



// WEBPACK FOOTER //
// ./src/containers/AccessorialsAndFees/AccessorialsAndFeesUiReducer.js